import { useEffect, useState } from "react";

interface FadeInProps {
  children: React.ReactNode;
  delayMilliseconds?: number;
  durationMilliseconds?: number;
}

export const FadeIn = ({
  children,
  delayMilliseconds = 500,
  durationMilliseconds = 500,
}: FadeInProps) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, delayMilliseconds);
    return () => clearTimeout(timer);
  }, [delayMilliseconds]);

  return (
    <div
      className="transition-opacity ease-in"
      style={{
        transitionDuration: `${durationMilliseconds}ms`,
        opacity: loading ? 0 : 1,
      }}
    >
      {children}
    </div>
  );
};
